import { menuItems } from "@peracto/peracto";

export const menu = {
    ...menuItems,
    products: {
        ...menuItems.products,
        children: {
            ...menuItems.products.children,
            vehicleCategories: {
                label: "Vehicle Categories",
                path: "/vehicle-categories",
                sortOrder: 35,
                roles: ["ROLE_ADMIN"],
            },
            tecdocBrandRules: {
                label: "TecDoc Brand Rules",
                path: "/tecdoc-brand-rules",
                sortOrder: 50,
                roles: ["ROLE_ADMIN"],
            },
        },
    },
};
